module.exports = __webpack_public_path__ + "img/20191207152733149.77944bd6.jpg";